import { render } from "./QuanTriMenu.vue?vue&type=template&id=7c45adc4"
import script from "./QuanTriMenu.vue?vue&type=script&lang=js"
export * from "./QuanTriMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__